import { render, staticRenderFns } from "./OrdersPageWarehouse.vue?vue&type=template&id=44306249&scoped=true"
import script from "./OrdersPageWarehouse.vue?vue&type=script&lang=js"
export * from "./OrdersPageWarehouse.vue?vue&type=script&lang=js"
import style0 from "./OrdersPageWarehouse.vue?vue&type=style&index=0&id=44306249&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44306249",
  null
  
)

export default component.exports